module.exports = __webpack_public_path__ + "static/media/1_r_fotoaparat1_82.71_59.07.362bd475.png";